import React from 'react';

const ContactPage = () => {
  return (
    <div className="pl-4 pt-8 md:p-8">
      <h1 className="text-3xl font-bold mb-4">Contact Us</h1>
      {/* Implement contact form or contact information here */}
    </div>
  );
};

export default ContactPage;
